import { render, staticRenderFns } from "./Solutions.vue?vue&type=template&id=e12dd678"
import script from "./Solutions.vue?vue&type=script&lang=js"
export * from "./Solutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/srv/app/components/button/Button.vue').default,CardInfoTags: require('/srv/app/components/card/CardInfoTags.vue').default,Tab: require('/srv/app/components/tab/Tab.vue').default})
